import { transitions, positions } from "react-alert";

export const options = {
  position: positions.TOP_RIGHT,
  timeout: 50000,
  offset: "1.875rem",
  transition: transitions.SCALE,
};
